import { useContext } from 'react';
import { useLazyDataModel } from '@thd-nucleus/data-sources';
import { ExperienceContext, useConfigService, useStoreId } from '@thd-nucleus/experience-context';
import {
  getMcvisID,
  getPageType,
  getSvocId,
  getItemId,
  getRecentSearchTerms,
} from '../utils/window-utils';
import {
  MESSAGE_ORIGIN_PREPOPULATED,
  MESSAGE_ORIGIN_CUSTOM,
  MESSAGE_ORIGIN_RETRY,
} from '../components/MagicApronAssistant/constants';

/**
 * @returns {[
 *   ({ userQuestion: string, timestamp: number }) => void,
 *   { data: object, loading: boolean, error: string }
 * ]}
 */
export const useAssistantBot = (session) => {
  const {
    channel,
    deliveryZip,
    isConsumerApp,
  } = useContext(ExperienceContext);
  const storeId = useStoreId();
  const llmNameFS = useConfigService('fs:magic-apron-assistant-bot-llm') || 'pro002';
  const [submitToBot, response] = useLazyDataModel('retrieveDetails', {
    lazy: true
  });

  const submitUserQuestion = ({
    userQuestion,
    timestamp,
    messageOrigin,
    suggestedQuestionPosition = null,
    isInitialSuggestedQuestion = false,
  }) => {

    let userTyped = '';
    if (messageOrigin === MESSAGE_ORIGIN_PREPOPULATED) {
      userTyped = `${isInitialSuggestedQuestion ? 'I' : 'N'}|${suggestedQuestionPosition}`;
    } else if (messageOrigin === MESSAGE_ORIGIN_RETRY) {
      userTyped = 'R|null';
    } else if (messageOrigin === MESSAGE_ORIGIN_CUSTOM) {
      userTyped = 'Y|null';
    }

    submitToBot({ variables: {
      userContext: {
        userIdentities: {
          mcvisId: getMcvisID(),
          svocId: getSvocId()
        },
        sessionId: session.sessionId,
        storeId,
        zipCode: deliveryZip,
        deviceType: channel === 'mobile' && isConsumerApp ? 'app' : channel,
        language: 'en-US'
      },
      pageContext: {
        pageType: getPageType(),
        referrerPage: window.document.referrer,
        timestamp,
        url: window.parent.location.href,
      },
      questionContext: {
        itemId: getItemId(),
        userQuestion,
        recentSearchTerms: getRecentSearchTerms(),
        user_typed: userTyped,
      },
      suggestedQuestions: true,
      followUpQuestions: false,
      model_name: llmNameFS
    } });
  };

  return [
    submitUserQuestion,
    response,
  ];
};
